import { Add } from '@mui/icons-material';
import { Fab, Tooltip } from '@mui/material';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { paths, replaceParams } from 'routing';
import { useGlobalBrandKey } from 'utils/globalState';
import { useStyles } from './styles';

export const BrandKeySpeedDial: FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const [brandKey] = useGlobalBrandKey();

  return (
    <Tooltip title={`Créer une recette ${brandKey}`}>
      <Fab
        className={classes.speedDial}
        color="primary"
        href={brandKey && replaceParams(paths.NEW, { brandKey })}
        onClick={(e) => {
          e.preventDefault();
          brandKey && history.push(replaceParams(paths.NEW, { brandKey }));
        }}
      >
        <Add />
      </Fab>
    </Tooltip>
  );
};
